import React from 'react'
import {ReactComponent as InfoSquareIcon} from "../../../assets/images/icon-square-info.svg";
import Styles from "../../../scss/subscriptions.module.scss";
interface INotification{
  message:string,
  type:string
}
export const NotificationStylings: { [key: string]: any } =
{
    Error:
    {
        backgroundColor: "#F3DCE3",
        color: "#F65164",
        fill:"#F65164"
    },
}
export  function Notification({message,type}:INotification) {
  return (
    <div style={{...NotificationStylings[type]}} className={Styles.Notification}>
      <p>{message}</p>
      <InfoSquareIcon fill={NotificationStylings[type].fill}/>
    </div>
  )
}
